import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import {CircularProgress, DialogActions, Grid, Typography} from "@mui/material";
import {translate} from "../../translate/translate";
import {Close} from "@mui/icons-material";


const GenericDialog = (props: any) => {
    const {
        open,
        onClose,
        title,
        labelButton,
        colorButton,
        children,
        handleConfirm,
        disableConfirm,
        loading,
        closeButtonText = "cancel",
	  	fullWidth = true,
	  	maxWidth = "sm",
        hideConfirmButton = false,
        disableClose = false,
        transparentHeader = false,
        confirmButtonColor,
        closeButtonColor,
    } = props;

    const handleCloseDialog = (result: boolean) => {
        onClose(result);
    };

    const handleClose = (event: any, reason: any) => {
        if (reason === 'backdropClick') {
            return;
        }
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose}
				fullWidth={fullWidth} maxWidth={maxWidth}>
            <Grid
                padding={transparentHeader ? 3 : 2}
                pb={transparentHeader ? 0 : 2}
                container
                justifyContent="space-between"
                alignItems="center"
                sx={transparentHeader ? {} : {backgroundColor: "primary.main"}}
            >
                <Grid>
                    <Typography sx={transparentHeader ? {
                        fontWeight: 700,
                        fontSize: "34px",
                        color: "#000000DE",
                    } : {color: "#ffffff", fontWeight: "bold", fontSize: "16px"}}>
                        {translate.t(title)}
                    </Typography>
                </Grid>
                <Grid sx={{cursor: "pointer", color: transparentHeader ? "action.active" : "#ffffff"}}>
                    <Close onClick={() => {
                        handleCloseDialog(false);
                    }}/>
                </Grid>
            </Grid>
            <DialogContent style={{overflow: "auto"}}>
                <Grid container flexDirection="column" gap={1}>
                    {children}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container justifyContent="flex-end" gap={1} padding={2}>
                    <Grid >
                        <Button
                            color="secondary"
                            variant="outlined"
                            disabled={disableClose && loading}
                            onClick={() => {
                                handleCloseDialog(false);
                            }}
                            sx={closeButtonColor ? {color: closeButtonColor, borderColor: closeButtonColor} : undefined}
                        >
                            {translate.t(closeButtonText).toUpperCase()}
                        </Button>
                    </Grid>
                    {!hideConfirmButton && (<Grid >
                        <Button
                            type="submit"
                            variant="contained"
                            color={colorButton ? colorButton : "error"}
                            onClick={() => {
                                handleConfirm();
                            }}
                            disabled={disableConfirm || loading}
                            sx={confirmButtonColor ? {backgroundColor: confirmButtonColor, "&:hover": {backgroundColor: confirmButtonColor, opacity: 0.9}} : undefined}
                        >
                            {translate.t(labelButton).toUpperCase()}
                            {loading && <CircularProgress sx={{marginLeft: '10px'}} size="20px" />}
                        </Button>
                    </Grid>)}
                </Grid>
            </DialogActions>
        </Dialog>
    );
};

export default GenericDialog;
